
import axios from 'axios';
import XAddress from 'vux/src/components/x-address/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {urlConfig} from '@/api/urlConfig';
import {education,nation} from '@/api/diseaseCommon';
import {promptMessage,fetch} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
export default {
data(){
return {
education,
nation,
certType:[],
submitdisabled:false,
brithSexshow:false,
toastShow:false,
toastTxt:'',
preVisitType:'',
sexoptions:[
{key:'1' ,value:'男'},
{key:'2' ,value:'女'}
],
address:[],
basemessage:{
name:'',
identyId:'',
wxh:'',
phone:'',
idType:'',
brithDate:'',
sex:'',

},
iconData:{
nameIcon:false,
phoneIcon:false,
idTypeIcon:false,
identyIdIcon:false,
sexIcon:false,
brithDateIcon:false,

}
}
},
methods:{
getTJRSFZ(){

fetch('get',urlConfig.pregnancyRegistratGetreferencePerson+ '?cardNo='+ this.$route.query.tjrno).then(response => {

this.tjrmessage = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {


})
this.getsfztype();
},
getopenid(){
axios.get(urlConfig.GetSfzh+ '?openid='+ this.basemessage.wxh).then(response => {
if (response.data.resultCode == 'success'){   //已注册
console.log(response.data.data.sfzh,4)
if(response.data.data.sfzh){
window.location.href = this.$route.query.jumpurl.replace(/\\/g,'');
}
}else{  //未注册
this.getTJRSFZ();

}

}).catch(error => {
promptMessage('提示',error);
})
},
IconClick(text){
this.toastShow = true;
this.toastTxt = text;
},
emtpvalidate(){
for(let i in this.basemessage){
this.basemessage[i] = this.basemessage[i].toString().replace(/(^\s*)|(\s*$)/g, "");
if(i != 'phone' && i != 'identyId'){
if(this.basemessage[i] == ''){
this.iconData[i+'Icon'] = true;
}else{
this.iconData[i+'Icon'] = false;
}
}else{
this.SFZvalidate();
this.telchange();
}

};


},
SFZvalidate () {

if (this.basemessage.idType == '01') {

let _this = this;
let code = this.basemessage.identyId;
var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
var row = true;
if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[X])$/.test(code)){
row=false;
_this.IconClick('证件号码有误！');
}else if(!city[code.substr(0,2)]){
row=false;
_this.IconClick('证件号码有误,地址编码错误！');

}else{

if(code.length == 18){
code = code.split('');
var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];

var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
var sum = 0;
var ai = 0;
var wi = 0;
for (var i = 0; i < 17; i++)
{
ai = code[i];
wi = factor[i];
sum += ai * wi;
}
if(parity[sum % 11] != code[17].toUpperCase()){
row=false;

}
if(row){


if(this.basemessage.identyId[16] % 2 == 0){  //如果是女
this.basemessage.sex = '2';

}else{
this.basemessage.sex = '1';

}
this.basemessage.brithDate = this.basemessage.identyId.substring(6,10) + '-' + this.basemessage.identyId.substring(10,12) + '-' + this.basemessage.identyId.substring(12,14)

}
}
}
_this.iconData.identyIdIcon = !row;

return row;



}else{
if(!this.basemessage.identyId){
this.IconClick( '请输入证件号码！')
this.iconData.identyIdIcon = true;
}else{
this.iconData.identyIdIcon = false;
}
}
}, // 验证身份证
sexchange(){
if(this.basemessage.sex == 2){
this.preVisitType = '01';
}else if(this.basemessage.sex == 1){
this.preVisitType = '04';
}
this.emtpvalidate();
},
telchange(){
let patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
this.$nextTick(function(){
this.basemessage.phone = this.basemessage.phone.trim().replace(patrn, "")
if(/^1[3456789]\d{9}$/.test(this.basemessage.phone) && this.basemessage.phone){
this.iconData.phoneIcon = false;
}else{
this.iconData.phoneIcon = true;
if(!this.basemessage.phone){
return false;
}
this.IconClick('电话号码格式不正确，请核实！');

}
})

}, //电话验证
getsfztype(){
this.certType = [];
fetch('post',urlConfig.pregnancyRegistratGetType).then(response => {
console.log(response)
for(let i=0;i<response.certType.length;i++){
this.certType.push({'key':response.certType[i].certCode,'value':response.certType[i].certName});

}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
})
},
certTypechange(){

if(this.basemessage.idType == '01'){
this.brithSexshow = false;
this.SFZvalidate();
}else{
this.brithSexshow = true;
}
this.emtpvalidate();
},   //身份证类型改变
submit(){
this.emtpvalidate();
let j = 0;
for(let i in this.iconData){
if(this.iconData[i]){
j++;
}
}
if(j == 0){  // 提交
this.paramsDJ = {
activityId: "",
belongArea: "",
birthday:this.basemessage.brithDate,
certType:this.basemessage.idType,
certNo:this.basemessage.identyId,
channelCardNo: this.tjrmessage.empNo,
channelContact: this.tjrmessage.preRefInfos[0].name,
channelId: this.tjrmessage.channelId,
channelInfoId: this.tjrmessage.empNo,
channelOutDoctor: this.tjrmessage.preRefInfos[0].outDocker,
channelOutDoctorId: this.tjrmessage.preRefInfos[0].outDockerId,
channelPhone: this.tjrmessage.preRefInfos[0].phone,
hospitalId: "82c6d395002e80810c77",
id: "",
name: this.basemessage.name,
phone: this.basemessage.phone,
preExclusive: 2,
preVisitType: this.preVisitType,
registerType: "",
remark: "",
sex: this.basemessage.sex,
userId: "",
vipConsult: "",
};
console.log(this.paramsDJ,'提交')
fetch('post',urlConfig.pregnancyRegistratSubmit,this.paramsDJ).then(response => {
this.submitZC();
this.submitdisabled = false;
}).catch(error => {
this.submitZC();
this.submitdisabled = false;

})

}else{
this.IconClick('还有选项未填写！');
}
console.log(this.basemessage,j)
},
submitZC(){
fetch('post','http://front.wh.jinxin-fertility.com/weixin/gzhRegister',this.basemessage).then(response => {
this.submitdisabled = false;
window.location.href = this.$route.query.jumpurl.replace(/\\/g,'');
}).catch(error => {
this.submitdisabled = false;

})
},
},
components: {
XAddress,Datetime,Cell,Toast,Group,XHeader,XButton,XInput,Icon,PopupRadio

},
mounted(){
document.title = '咨询注册';
let _this = this;
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.basemessage.wxh = this.$route.query.hzwxh;
getken(this.getopenid);
var uploadBtn = document.querySelector('#upload');
uploadBtn.addEventListener('change',function(){
var imgLen = this.files.length;
if(imgLen>1){
promptMessage('提示','只能选择一张图片');
return false;
}
var reader = new FileReader();
reader.readAsDataURL(this.files[0]);
reader.onload = function(e) {
let imgindex = reader.result.indexOf(',');
let imgurl = reader.result.substring(imgindex+1,reader.result.length)
_this.$store.commit('updateLoadingStatus',{isLoading:true});
axios({
method: 'post',
url: 'https://dm-51.data.aliyun.com/rest/160601/ocr/ocr_idcard.json',
data: {
"image":  imgurl,
"configure": "{\"side\":\"face\"}"
},
headers:{
Authorization:'APPCODE a98612384f8a4bec8ee691f5c17bfbb2'
}
}).then(function (response) {
if(!response.data.success){
promptMessage('提示','身份证信息读取失败，请重新上传身份证图片');
}else{
_this.IconClick('身份证识别成功，信息已智能填充');
_this.basemessage.brithDate =response.data.birth.substring(0,response.data.birth.length-4)+ '-' +response.data.birth.substring(response.data.birth.length-4,response.data.birth.length-2)+'-'+response.data.birth.substring(response.data.birth.length-2,response.data.birth.length)
_this.basemessage.identyId = response.data.num;
_this.basemessage.name = response.data.name;
_this.basemessage.idType = '01';
if (response.data.sex == '女'){
_this.basemessage.sex = '2';
}else if (response.data.sex == '男'){
_this.basemessage.sex = '1';
}

}
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(function (error) {
promptMessage('提示',error);
_this.$store.commit('updateLoadingStatus',{isLoading:false});
});
};
_this.$refs.uploadref.value = null;

},false);
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
})

}
}



// WEBPACK FOOTER //
// ./src/project/internetHospital/consultationRegistration.vue